import { IContextualMenuItem } from "@fluentui/react";
import React from "react";
import { useSelector } from "react-redux";
import { useLazyPublishItemQuery } from "../../../src/taskpane/components/_v2/redux/api/sharepoint/api-sharepoint-slice";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { SharePointFolderContentTypeIds } from "../../../src/taskpane/config/constants";
import authModule from "../../../utilities/AuthModule";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { menuItemIconStyles } from "../../../src/taskpane/config/controlStyles";
import { ArrowExportUp20Regular } from "../../../src/taskpane/components/_v2/components/SvgIcons/ArrowExportUp20Regular";

export function useMenuItem_Publish(
    selectedItems: any[],
    waitFor: boolean,
    setWaitFor: (waitFor: boolean) => void,
    setIsPublish: (isPublish: boolean) => void,
    setShowCheckinDialog: (showCheckinDialog: boolean) => void,
    isInOneDrive: boolean,
    setGridItemIsBusy: (items: any[], isBusy: boolean) => void,
    updateGridItems: (items: any[]) => void,
    setIsCMErrorModalOpen: (isCMErrorModalOpen: boolean) => void,
    setErrorMessage?: (errorMessage: string) => void
) {
    const languageStrings = React.useContext(LanguageContext);

    const currentDirectory = useSelector((state: RootState) => state.workingDirectories.workingDirectories.length > 0 ? state.workingDirectories.workingDirectories[state.workingDirectories.workingDirectories.length - 1] : null);

    const [publishItem] = useLazyPublishItemQuery();

    const submitForApproval = React.useCallback(async () => {
        setGridItemIsBusy(selectedItems, true);
        setWaitFor(true);
        try {
            await publishItem({
                siteUrl: currentDirectory?.webUrl,
                uniqueId: selectedItems[0].UniqueId.replace(/[{}]/g, ""),
                accessToken: await authModule.getSharePointAccessToken(),
                comment: ''
            }).unwrap();
        } catch (error) {
            setIsCMErrorModalOpen(true);
            setErrorMessage(error?.data?.['odata.error']?.message?.value || "An unknown error occurred.");
        } finally {
            updateGridItems(selectedItems); // Should run regardless of success or failure to refresh state
            setWaitFor(false);
        }
    }, [
        selectedItems, currentDirectory, publishItem, setGridItemIsBusy,
        setWaitFor, updateGridItems, setIsCMErrorModalOpen, setErrorMessage
    ]);

    const menuItem_Publish = React.useMemo(() => {
        const hasSingleSelection = selectedItems?.length === 1;
        if (isInOneDrive || !hasSingleSelection) {
            return null;
        }

        const selectedItem = selectedItems[0];
        const moderationStatus = selectedItem['_ModerationStatus.'];

        const isNotCheckedOut = !selectedItem.CheckoutUser;
        const isNotFolder = !selectedItem.ContentTypeId?.startsWith(SharePointFolderContentTypeIds.folder);
        const hasMinorVersion = (+selectedItem._UIVersion % 512) > 0;

        const isInDraftOrRejected = moderationStatus === '3' || moderationStatus === '1';
        const isInPending = moderationStatus === '2';

        const shouldShowMenuItem =
            isNotCheckedOut &&
            isNotFolder &&
            hasMinorVersion &&
            !isInPending;

        if (shouldShowMenuItem) {
            const text = isInDraftOrRejected ? languageStrings.SubmitForApproval : languageStrings.Publish;
            const onClick = isInDraftOrRejected
                ? submitForApproval
                : () => {
                    setIsPublish(true);
                    setShowCheckinDialog(true);
                };

            return {
                key: 'publish',
                disabled: waitFor === true,
                text: text,
                // iconProps: { iconName: "PublishContent" },
                iconProps: {},
                onRenderIcon: () => <ArrowExportUp20Regular className={menuItemIconStyles} />,
                onClick: onClick,
            } as IContextualMenuItem;
        }

        return null;

    }, [
        selectedItems, waitFor, isInOneDrive, currentDirectory, languageStrings,
        submitForApproval, setIsPublish, setShowCheckinDialog
    ]);

    return {
        menuItem_Publish
    }

}